import { useEffect } from 'react';

export default function useHeroObserver(anchor: 'top' | 'bottom' = 'top') {
  useEffect(() => {
    const element = document.querySelector('[data-nav-theme]');
    const header = document.querySelector('[data-nav-root]');

    const setFillLevel = (level: number) => (header as HTMLDivElement)?.style.setProperty('--fill', level.toString());

    if (!header || !element) {
      setFillLevel(1);
      return;
    }

    const headerHeight = header.clientHeight;
    let isVisible = false;

    const handleVisibility: IntersectionObserverCallback = (entries) => {
      const isIntersecting = entries[0].isIntersecting;
      if (isIntersecting && !isVisible) {
        updatePosition();
        window.addEventListener('scroll', updatePosition);
      }
      if (!isIntersecting && isVisible) {
        updatePosition();
        window.removeEventListener('scroll', updatePosition);
        setFillLevel(1);
      }
      isVisible = isIntersecting;
    };

    function updatePosition() {
      if (!element || !header) return;

      const { top, height } = element.getBoundingClientRect();
      const headerTop = header.getBoundingClientRect().top;
      const absoluteTop = Math.abs(top - headerTop);
      const offset = anchor === 'bottom' ? absoluteTop + headerHeight - height : absoluteTop - 10;
      const percentage = Math.min(offset >= 0 ? offset / headerHeight + 0.05 : 0, 1);
      setFillLevel(percentage);
    }

    updatePosition();
    const observer = new IntersectionObserver(handleVisibility, {});
    observer.observe(element);

    return () => {
      observer.unobserve(element);
      window.removeEventListener('scroll', updatePosition);
    };
  }, []);
}
